import UIManager from "../../Shared/UIManager"
import NetworkLogic from "../../Shared/NetworkLogic"
const i18n = require('LanguageData');
const { ccclass, property } = cc._decorator

@ccclass
export default class BalanceDetails extends cc.Component {
    @property(cc.Layout)
    lytContentRecords: cc.Layout = null

    @property(cc.Layout)
    lytContentPayTypes: cc.Layout = null
    @property(cc.Layout)
    lytContentCurrencyTypes: cc.Layout = null
    @property(cc.Node)
    nodeTemplatePayType: cc.Node = null
    @property(cc.Node)
    nodeTemplateCurrencyType: cc.Node = null
    @property(cc.Node)
    nodeTemplateRecord: cc.Node = null

    @property(cc.Node)
    nodeScrollView: cc.Node = null

    @property(cc.Node)
    nodeTimes: cc.Node = null

    @property(cc.Node)
    nodePayTypes: cc.Node = null
    @property(cc.Node)
    nodeCurrencyTypes: cc.Node = null

    @property(cc.Label)
    lbTime: cc.Label = null

    @property(cc.Label)
    lbPayType: cc.Label = null
    @property(cc.Label)
    lbCurrencyType: cc.Label = null

    private _startTime = ""
    private _endTime = ""
    private _payType = ""
    private _currencyType = ""

    onLoad() {
        this.nodeTemplatePayType.parent = null
        this.nodeTemplateCurrencyType.parent = null
        this.nodeTemplateRecord.parent = null
        this.hideNodeList()
        this.node.parent.parent.on(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.on(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.on(cc.Node.EventType.TOUCH_CANCEL, this.hideNodeList, this)
    }

    start() {
        let date = new Date()
        this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
        this._endTime = date["format"]("yyyy-MM-dd ") + "23:59:59"
        this.createPayTypes();
        this.createCurrencyTypes();
    }

    onDisable() {
        this.hideNodeList()
    }

    onDestroy() {
        this.nodeTemplatePayType.destroy()
        this.nodeTemplateCurrencyType.destroy()
        this.nodeTemplateRecord.destroy()
        this.node.parent.parent.off(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.off(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.off(cc.Node.EventType.TOUCH_CANCEL, this.hideNodeList, this)
    }

    onBtnClick(event, userData) {
        if (userData === "today") {
            this.selectTimeNode(event.target, userData)
        } else if (userData === "yesterday") {
            this.selectTimeNode(event.target, userData)
        } else if (userData === "month") {
            this.selectTimeNode(event.target, userData)
        } else if (userData === "payType") {
            this.selectPayType(event.target["payTypeCfg"])
        } else if (userData === "currencyType") {
            this.selectCurrencyType(event.target["currencyTypeCfg"])
        }
        else if (userData === "nodeTimes") {
            this.nodeTimes.active = !this.nodeTimes.active
        } else if (userData === "nodePayTypes") {
            this.nodePayTypes.active = !this.nodePayTypes.active
        }
        else if (userData === "nodeCurrencyTypes") {
            this.nodeCurrencyTypes.active = !this.nodeCurrencyTypes.active
        }
    }

    hideNodeList() {
        this.nodeTimes.active = false
        this.nodePayTypes.active = false
        this.nodeCurrencyTypes.active = false
    }

    private selectTimeNode(node: cc.Node, userData) {
        this.nodeTimes.active = false
        this.lbTime.string = node.getChildByName("name").getComponent(cc.Label).string

        if (userData === "today") {
            let date = new Date()
            this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
            this._endTime = date["format"]("yyyy-MM-dd ") + "23:59:59"
        } else if (userData === "yesterday") {
            let date = new Date()
            date.setDate(date.getDate() - 1)
            this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
            this._endTime = date["format"]("yyyy-MM-dd ") + "23:59:59"
        } else if (userData === "month") {
            let date = new Date()
            date.setDate(1)
            this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
            this._endTime = (new Date())["format"]("yyyy-MM-dd ") + "23:59:59"
        }

        this.queryRecords()
    }

    private selectPayType(payTypeCfg) {
        this.nodePayTypes.active = false
        this.lbPayType.string = payTypeCfg ? payTypeCfg["label"] : i18n.t('PlayerCenter.all')
        this._payType = payTypeCfg ? payTypeCfg["value"] : "all"
        this.queryRecords()
    }

    private selectCurrencyType(currencyTypeCfg) {
        this.nodeCurrencyTypes.active = false;
        this.lbCurrencyType.string = currencyTypeCfg ? currencyTypeCfg["currencyName"] : i18n.t('PlayerCenter.all')
        this._currencyType = currencyTypeCfg ? currencyTypeCfg["currencyType"] : null
        this.queryRecords()
    }

    private createPayTypes() {
        let node = cc.instantiate(this.nodeTemplatePayType)
        node.getChildByName("name").getComponent(cc.Label).string = i18n.t('PlayerCenter.all')
        node.parent = this.lytContentPayTypes.node
        this.selectPayType(undefined)

        NetworkLogic.payTypeList(function (data) {
            data.coinTypeList.forEach(payTypeCfg => {
                let node = cc.instantiate(this.nodeTemplatePayType)
                node.getChildByName("name").getComponent("LocalizedLabel").dataID = payTypeCfg["label"]
                node["payTypeCfg"] = payTypeCfg;
                node.parent = this.lytContentPayTypes.node
            });
        }.bind(this))
    }

    private createCurrencyTypes() {
        let node = cc.instantiate(this.nodeTemplateCurrencyType)
        node.getChildByName("name").getComponent(cc.Label).string = i18n.t('PlayerCenter.all')
        node.parent = this.lytContentCurrencyTypes.node
        this.selectCurrencyType(undefined)

        /*这里等接口
        * 0:
            createBy: "admin"
            createTime: "2020-10-03 11:49:33"
            currencyDefault: 1
            currencyName: "人民币"
            currencyRate: 6.9
            currencySymbol: "¥"
            currencyTitle: "人民币"
            currencyType: "CNY"
            id: 1
            imsStatus: 1
            languageFlag: "zh_CN"
            sortNum: 1
            status: 1
            updateBy: "mack001"
            updateTime: "2020-10-07 20:37:30"*/
        NetworkLogic.currencyTypeList(function (data) {
            for (let i = 0;i < data.length;i++){
                let currencyTypeCfg  = data[i]
                let node = cc.instantiate(this.nodeTemplateCurrencyType);
                node.getChildByName("name").getComponent("LocalizedLabel").dataID = currencyTypeCfg.currencyName
                node["currencyTypeCfg"] = currencyTypeCfg
                node.parent = this.lytContentCurrencyTypes.node
            }

        }.bind(this))
    }



    private queryRecords() {


        UIManager.showLoadingUI()
        NetworkLogic.balanceDetailsList(this._startTime, this._endTime, this._payType,this._currencyType ,function (data) {
            UIManager.hideLoadingUI();
            this.lytContentRecords.node.removeAllChildren()
            this.lytContentRecords.node.destroyAllChildren()
            cc.log("===列表数据：",data);
            data.data && data.data.forEach(item => {
                let node = cc.instantiate(this.nodeTemplateRecord);
                node.parent = this.lytContentRecords.node
                node.getChildByName("time").getComponent(cc.Label).string = item.time
                node.getChildByName("type").getComponent(cc.Label).string = item.type;
                node.getChildByName("currencyType").getComponent(cc.Label).string = item.currencyName;

                node.getChildByName("yue").getComponent(cc.Label).string = item.currencySymbol + item.changeBalance
                //node.getChildByName("currencyRate").getComponent(cc.Label).string = item.currencyRate ? item.currencyRate : '/';
                this.lytContentRecords.node.children.length % 2 === 1 && (node.getChildByName("bg").opacity = 100)

                if (parseFloat(item.money) > 0) {
                    node.getChildByName("money").color = cc.color(80, 192, 255)
                    node.getChildByName("money").getComponent(cc.Label).string = "+" +  item.currencySymbol +  item.money
                } else {
                    node.getChildByName("money").color = cc.color(190, 74, 74);
                    node.getChildByName("money").getComponent(cc.Label).string =  "-" + item.currencySymbol +  Math.abs(item.money) ;
                }

                node.active = true

            });
        }.bind(this))
    }
}